import { OfferedService, Psychologist, SlotType } from "utils/interfaces"
import { isBookingAvailable } from "utils/bookingAvailable"

class ServiceType {
    id!: number
    name!: string
    description!: string
    online!: boolean
    family!: boolean
    price!: number
    public!: boolean

    constructor(offered_service: OfferedService) {
        Object.assign(this, {
            id: offered_service.service_type_id,
            name: offered_service.name,
            description: offered_service.description,
            online: offered_service.online,
            family: offered_service.family,
            price: offered_service.price,
            public: offered_service.public,
        })
    }

    isAvailableForBooking = (psy: Psychologist) => {
        return isBookingAvailable(psy, [this.locationStr()])
    }

    displayStr() {
        return this.name
    }

    locationStr() {
        return this.online ? SlotType.Online : SlotType.InPerson
    }
}

export { ServiceType }
